import { ExtractServiceRefreshType } from '~src/schedule/serverApi/requests/CreateSelfServiceScheduleExtractTasksRequest';

import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { SelfServiceSchedule } from '../types/SelfServiceSchedule';

export interface CreateSelfServiceScheduleExtractTasksWithExtraArgsRequestParams {
  schedule: SelfServiceSchedule;
  scheduleName: string;
  targetIds: number[];
  targetType: string;
  type: ExtractServiceRefreshType;
  level: string;
  startingItems: string[];
}

export class CreateSelfServiceScheduleExtractTasksWithExtraArgsRequest extends Request<CreateSelfServiceScheduleExtractTasksWithExtraArgsRequestParams, IResult> {
  constructor(params: CreateSelfServiceScheduleExtractTasksWithExtraArgsRequestParams) {
    super('createExtractTasksSelfServiceSchedulesWithExtraArgs', params);
  }
}
